<template>
  <section>
    <div class="mod-block">
      <h3 class="title">商品自定义属性</h3>
      <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form" :rules="rules">
        <el-form-item label="产地" prop="placeOfProduction">
          <mc-remote-select-opt
            v-model="form.placeOfProduction"
            listKey="result"
            valueKey="udaValue"
            labelKey="udaValue,udaValueDesc"
            method="post"
            query="udaVauleOrUdaName"
            url="/commoditymanagement/uda/getUdaValuesByUda"
            :ajaxData="{__isRP: false, udaKey: 'placeOfProduction'}"
            clearable
            >
          </mc-remote-select-opt>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <mc-remote-select-opt
            v-model="form.brand"
            listKey="result"
            valueKey="udaValue"
            labelKey="udaValue,udaValueDesc"
            method="post"
            query="udaVauleOrUdaName"
            url="/commoditymanagement/uda/getUdaValuesByUda"
            :ajaxData="{__isRP: false, udaKey: 'brand'}"
            clearable
            @change="handleSelectBrand"
            >
          </mc-remote-select-opt>
        </el-form-item>
        <el-form-item label="正常/促销" prop="salesStrategy">
          <el-select v-model="form.salesStrategy" @visible-change="changeSelect($event,'salesStrategy')">
            <el-option
              v-for="item in salesStrategy"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="全国性/区域性" prop="marketArea">
          <el-select v-model="form.marketArea" @visible-change="changeSelect($event,'marketArea')">
            <el-option
              v-for="item in marketArea"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="seasonGoodsOrYearGoods" class="label-text">
          <span slot="label">季节性/年节商品</span>
          <el-select v-model="form.seasonGoodsOrYearGoods" @visible-change="changeSelect($event,'seasonGoodsOrYearGoods')">
            <el-option
              v-for="item in seasonGoodsOrYearGoods"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否进口食品" prop="isImportedFood">
          <el-select v-model="form.isImportedFood" @visible-change="changeSelect($event,'isImportedFood')">
            <el-option
              v-for="item in isImportedFood"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份" prop="saleYear">
          <el-input v-model="form.saleYear"></el-input>
        </el-form-item>
        <el-form-item label="是否柜组码" prop="isCabinetCode">
          <el-select v-model="form.isCabinetCode" @visible-change="changeSelect($event,'isCabinetCode')">
            <el-option
              v-for="item in isCabinetCode"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isTransfer" class="label-text">
          <span slot="label">是否可以进行店内调拨</span>
          <el-select v-model="form.isTransfer" @visible-change="changeSelect($event,'isTransfer')">
            <el-option
              v-for="item in isTransfer"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isTasteGoods" class="label-text">
          <span slot="label">口味商品-销售商品</span>
          <el-select v-model="form.isTasteGoods" @visible-change="changeSelect($event,'isTasteGoods')">
            <el-option
              v-for="item in isTasteGoods"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isPrintShelfLife" class="label-text">
          <span slot="label">是否打印保质期</span>
          <el-select v-model="form.isPrintShelfLife" @visible-change="changeSelect($event,'isPrintShelfLife')">
            <el-option
              v-for="item in isPrintShelfLife"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保质期天数" prop="shelfLife">
          <el-input v-model="form.shelfLife"></el-input>
        </el-form-item>
        <el-form-item label="销售保质期" prop="udaSaleBzq">
          <el-input v-model="form.udaSaleBzq"></el-input>
        </el-form-item>
        <el-form-item label="储存条件" prop="udaStoreCause">
          <el-select v-model="form.udaStoreCause" @visible-change="changeSelect($event,'udaStoreCause')">
            <el-option
              v-for="item in udaStoreCause"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="食用方法" prop="udaEatMethod">
          <el-select v-model="form.udaEatMethod" @visible-change="changeSelect($event,'udaEatMethod')">
            <el-option
              v-for="item in udaEatMethod"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配料" prop="udaMixture">
          <el-input v-model="form.udaMixture"></el-input>
        </el-form-item>
        <el-form-item label="自有品牌" prop="udaOwnerBarnd">
          <el-select v-model="form.udaOwnerBarnd" @visible-change="changeSelect($event,'udaOwnerBarnd')">
            <el-option
              v-for="item in udaOwnerBarnd"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="腾万里商品" prop="udaTwlItem">
          <el-select v-model="form.udaTwlItem" @visible-change="changeSelect($event,'udaTwlItem')">
            <el-option
              v-for="item in udaTwlItem"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联名卡商品" prop="udaJointlyCard">
          <el-select v-model="form.udaJointlyCard" @visible-change="changeSelect($event,'udaJointlyCard')">
            <el-option
              v-for="item in udaJointlyCard"
              :key="item.udaValue"
              :label="item.udaValueDesc"
              :value="item.udaValue.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="蔬果群组" prop="udaVegeFruits">
          <mc-remote-select-opt
            v-model="form.udaVegeFruits"
            listKey="result"
            valueKey="udaValue"
            labelKey="udaValue,udaValueDesc"
            method="post"
            query="udaVauleOrUdaName"
            url="/commoditymanagement/uda/getUdaValuesByUda"
            :ajaxData="{__isRP: false, udaKey: 'udaVegeFruits'}"
            clearable
            @change="handleSelectVege"
            >
          </mc-remote-select-opt>
        </el-form-item>
        <el-form-item label="是否线上专用" prop="isOnLineSpecial">
          <el-select v-model="form.isOnLineSpecial">
            <el-option value="1" label="是">是</el-option>
            <el-option value="0" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否原材料" prop="isRawMaterial">
          <el-select v-model="form.isRawMaterial">
            <el-option value="1" label="是">是</el-option>
            <el-option value="2" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isGiftItem" class="label-text">
          <span slot="label">是否礼品卡商品</span>
          <el-select v-model="form.isGiftItem">
            <el-option value="1" label="是">是</el-option>
            <el-option value="0" label="否">否</el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getMod', 'getComData'],
    data () {
      return {
        deptKey: [],
        timeout: null,
        salesStrategy: [],
        marketArea: [],
        seasonGoodsOrYearGoods: [],
        isImportedFood: [],
        isCabinetCode: [],
        isTransfer: [],
        isTasteGoods: [],
        isPrintShelfLife: [],
        udaStoreCause: [],
        udaEatMethod: [],
        udaOwnerBarnd: [],
        udaTwlItem: [],
        udaJointlyCard: [],
        form: {
          placeOfProduction: '',
          brand: '',
          brandCode: '',
          salesStrategy: '',
          marketArea: '',
          seasonGoodsOrYearGoods: '',
          isImportedFood: '',
          saleYear: '',
          isCabinetCode: '',
          isTransfer: '',
          isTasteGoods: '',
          isPrintShelfLife: '',
          shelfLife: '',
          udaSaleBzq: '',
          udaStoreCause: '',
          udaEatMethod: '',
          udaMixture: '',
          udaOwnerBarnd: '',
          udaTwlItem: '',
          udaJointlyCard: '',
          udaVegeFruits: '',
          isOnLineSpecial: '',
          isRawMaterial: '',
          isGiftItem: ''
        },
        rules: {}
      }
    },
    methods: {
      getRules () {
        let ar = ['placeOfProduction', 'brand', 'salesStrategy', 'marketArea', 'seasonGoodsOrYearGoods', 'isImportedFood', 'saleYear', 'isCabinetCode', 'isTransfer', 'isTasteGoods', 'isPrintShelfLife', 'shelfLife', 'udaSaleBzq', 'udaStoreCause', 'udaEatMethod', 'udaMixture', 'udaOwnerBarnd', 'udaTwlItem', 'udaJointlyCard', 'udaVegeFruits']
        let map = {}
        ar.forEach(item => {
          map[item] = [
            {validator: this.$validate.required, noRequired: !this.deptKey.includes(item), trigger: 'blur'},
            {required: this.deptKey.includes(item), trigger: 'blur', message: '输入不能为空'}
          ]
        })
        return map
      },
      //根据uda信息查询uda下拉框
      getSelectList(name){
        let para = {
          udaKey:name,
          __isRP: false
        };
        this.$ajax.post('/commoditymanagement/uda/getUdaValuesByUda', para).then(res => {
          if (res && res.code == "0" && res.msg =='success') {
            let result = res.result;
            this[name] = result;
          }
        });
      },
      // 下拉框出现 调接口
      changeSelect(val, name){
        if (val == true) {
          this.getSelectList(name);
        }
      },
      //合同签订品牌下拉搜索框选中事件
      handleSelectBrand(item) {
        this.form.brandCode = item.CODE ? Number(item.CODE) : '';
      },
      handleSelectVege(){

      },
      //根据大类查询该大类必填UDA
      getItemforUDA({dept}){
        return this.$ajax.post('/commoditymanagement/udaItemDefaults/selectRequiredUdaByDept', {dept, __isRP: false}).then(res => {
          if (res && res.code == "0" && res.msg =='success') {
            this.deptKey = res.result;
          }
        });
      },
      getSelectData () {
        let ar = ['salesStrategy', 'marketArea', 'seasonGoodsOrYearGoods', 'isImportedFood', 'isCabinetCode', 'isTransfer', 'isTasteGoods', 'isPrintShelfLife', 'udaStoreCause', 'udaEatMethod', 'udaOwnerBarnd', 'udaTwlItem', 'udaJointlyCard']
        ar.forEach(item => {
          this.changeSelect(true, item)
        })
      }
    },
    mounted () {
      // 编辑
      let {editData} = this.getComData()
      if (editData.udaModel) {
        Object.assign(this.form, editData.udaModel)
        this.getSelectData()
      }
      // 基本信息获取数据后
      let $basicInfo = this.getMod('basicInfo')
      $basicInfo.$on('updated', () => {
        this.getItemforUDA($basicInfo.form).then(rs => {
          this.rules = this.getRules()
          this.$nextTick(() => {
            this.$refs.form && this.$refs.form.clearValidate()
          })
        })
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/standard/product-custom.vue